module.exports = __webpack_public_path__ + "img/bg06.7f300927.gif";